<template>
  <div class="iosbuy">
    <p class="title">自动续费协议</p>
    <div class="block">
      <p class="common-p">
        1. 连续包月是在您已开启会员订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权心潮在您已开通的会员订阅服务即将到期时，从您的自有充值账户、与心潮帐号绑定的第三方支付账户、银行卡、通讯账号、iTunes账户（简称“账户”）等代扣下一个计费周期的月卡服务费用。扣费时间为计费周期到期前24小时内。
      </p>
      <p class="common-p">
        2. 您需要将心潮帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。
      </p>
      <p class="common-p">3. 您可通过下述途径取消已开通的自动续费服务：</p>
      <p class="common-p">（1）苹果手机在 iOS设备“设置” → “iTunes Store 与 App Store” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少24小时前取消自动续费功能，将会自动续订及扣款。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iosbuy',
  mounted () {
    document.title = '自动续费协议'
  }
}
</script>

<style lang="scss" scoped>
.iosbuy {

  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(21px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }
}
</style>
